<template>
  <v-toolbar class="ml-4 wd-100" color="transparent">
    <v-toolbar-title style="font-size: 24px; font-weight: bold"
      >{{ this.projeto }} - Atores</v-toolbar-title
    >
    <AtorModal
      v-if="isDev"
      @ator-criado="fetchAtores"
      :id-projeto="this.idProjeto"
    />
  </v-toolbar>

  <v-table
    class="ma-8 mt-1 usecase--table elevation-1"
    style="background: transparent"
    fixed-header="true"
    density="comfortable"
    ><thead class="text-grey">
      <tr>
        <th style="border-left: thin solid #efefef" class="text-left text-grey">
          Nome
        </th>
        <th
          style="border-left: thin solid #efefef"
          class="rounded-te-lg text-left text-grey"
        >
          Csu relacionados
        </th>
        <th
          v-if="isDev"
          style="border-left: thin solid #efefef"
          class="text-left text-grey"
        >
          Ações
        </th>
      </tr>
    </thead>
    <div class="split"></div>
    <tbody>
      <tr v-for="item in ator" :key="item">
        <td style="border-left: thin solid #efefef" class="text-left">
          {{ item.nome_ator }}
        </td>
        <td style="border-left: thin solid #efefef" class="text-left">
          {{
            csuRelacionados[item.id_ator]
              ? csuRelacionados[item.id_ator]?.length == 0
                ? 'Nenhum'
                : csuRelacionados[item.id_ator]?.length <= 3
                ? csuRelacionados[item.id_ator]?.join(', ')
                : csuRelacionados[item.id_ator]?.slice(0, 3).join(', ') + '...'
              : '...'
          }}
        </td>
        <td
          v-if="isDev"
          style="border-left: thin solid #efefef"
          class="text-left"
        >
          <div class="d-inline-block mr-6">
            <EditAtorModal
              @ator-editado="fetchAtores"
              :id="item.id_ator"
              :nome-prop="item.nome_ator"
            />
          </div>
          <div class="d-inline-block ml-2">
            <DeleteAtorModal @ator-removido="fetchAtores" :id="item.id_ator" />
          </div>
        </td>
      </tr>
    </tbody>
  </v-table>

  <v-container v-if="this.isLoading" class="d-flex justify-center align-center">
    <v-progress-circular class="text-center" indeterminate size="20" />
  </v-container>
</template>

<script>
/**
 * @module AtorTable
 * @desc Tela que lista os atores de um projeto
 * @vue-data {String} idProjeto - O id do projeto
 * @vue-data {String} [projeto=''] Nome do projeto
 * @vue-data {Array.<Object>} [ator=[]] Lista de objetos
 * com informações sobre os atores
 * @vue-data {Boolean} [isLoading=false] Flag que indica se
 * as informações já foram carregadas
 * @vue-computed {Boolean} isDev - Flag que indica se o usuário
 * atual é desenvolvedor no projeto
 */
import axios from 'axios';

import AtorModal from '@/components/dialogs/AtorModal.vue';
import DeleteAtorModal from '@/components/dialogs/DeleteAtorModal.vue';
import EditAtorModal from '@/components/dialogs/EditAtorModal.vue';
import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  name: 'AtorTable',
  components: {
    AtorModal,
    EditAtorModal,
    DeleteAtorModal,
  },
  data() {
    return {
      idProjeto: this.$route.params.idProjeto,
      projeto: '',
      ator: [],
      atoresId: [],
      atorAtual: null,
      csuRelacionados: {},
      isLoading: false,
      dialog: false,
    };
  },
  created() {
    this.fetchAtores();
    this.projeto = localStorage.getItem('projeto');
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
  },
  methods: {
    fetchCsuRelacionados() {
      this.isLoading = true;
      for (let i = 0; i < this.atoresId.length; i++) {
        axios
          .get(apiUrl + `/api/v1/ator/csuRelacionados/${this.atoresId[i]}`, {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          })
          .then((res) => {
            this.csuRelacionados[this.atoresId[i]] = res.data.csu.map(
              (csu) => csu.identificador,
            );
          })
          .catch((error) => console.log(error))
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    /**
     * Faz uma requisição HTTP para obter os atores do projeto.
     */
    fetchAtores() {
      this.isLoading = true;
      axios
        .get(apiUrl + `/api/v1/ator/projeto/${this.idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          this.ator = res.data.ator;
          this.atoresId = res.data.ator.map((ator) => ator.id_ator);
          this.fetchCsuRelacionados();
          console.log(this.csuRelacionados);
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.usecase--table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.usecase--table tbody tr {
  background-color: #fff;
}

.usecase--table a {
  text-decoration: none;
  color: black;
}

.limit {
  width: calc(100% - 50px);
}
</style>
